<template>
  <div class="home" :class="[setLayoutColor]">
    <div class="home__banner">
      <SwiperBanner />
      <div class="home__banner_container">
        <div class="home__banner_title">BRIXO <span>Bonus</span></div>
        <div class="home__banner_text">
          Программа разработана для официальных дистрибьюторов продукции brixo и их клиентов (сетей магазинов, дилеров, магазинов,
          интернет-магазинов и СТО)
        </div>
      </div>
    </div>
    <div class="home__rules">
      <div class="home__rules_title">
        <MainTitle title="Правила программы" />
      </div>
      <div class="home__rules_rules">
        <RulesCard v-for="(item, index) in rules" :key="'A' + index" :text="item.text" :color="item.color" :shape="item.shape" />
      </div>
    </div>
    <div class="home__prizes">
      <div class="home__prizes_title">
        <MainTitle title="Подарки" />
      </div>
      <PrizeSection />
    </div>
  </div>
</template>

<script>
import SwiperBanner from "@/components/ui/Swiper/SwiperBanner.vue";
import MainTitle from "@/components/ui/Title/MainTitle.vue";
import RulesCard from "@/components/ui/Cards/RulesCard.vue";
import PrizeSection from "@/components/home/PrizeSection.vue";

export default {
  name: "HomeView",
  components: {
    SwiperBanner,
    MainTitle,
    RulesCard,
    PrizeSection,
  },
  data() {
    return {
      rules: [
        {
          text: "Регистрируйтесь в программе лояльности",
          color: "blue",
          shape: "round",
        },
        {
          text: "Совершайте покупки",
          color: "purple",
          shape: "bottom-left",
        },
        {
          text: "Получайте бонусы",
          color: "orchid",
          shape: "left",
        },
        {
          text: "Заказывайте подарки",
          color: "red",
          shape: "top-right",
        },
      ],
    };
  },
  computed: {
    layoutColor() {
      return this.$store.getters.GET_LAYOUT_COLOR;
    },
    setLayoutColor() {
      return `home_${this.layoutColor}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;

  &_purple {
    & .home__banner_title {
      & span {
        color: $color-yellow;
      }
    }

    // & .home__prizes {
    //   background: $color-purple-10 url("@/assets/images/background-pattern.svg") no-repeat scroll;
    // }
  }

  &_red {
    & .home__banner_title {
      & span {
        color: $color-dark-yellow;
      }
    }

    // & .home__prizes {
    //   background: $color-red-10 url("@/assets/images/background-pattern-red.svg") no-repeat scroll;
    // }
  }

  &__banner {
    width: 100%;
    position: relative;
    margin-bottom: 50px;

    &_container {
      z-index: 2;
      max-width: 670px;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-12%, -85%);
    }

    &_title {
      text-transform: lowercase;
      font-weight: 700;
      font-size: 120px;
      line-height: 144px;
    }

    &_text {
      font-size: 30px;
      line-height: 36px;
    }
  }

  &__rules {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 140px;

    &_title {
      padding-bottom: 100px;
    }

    &_rules {
      display: flex;
    }
  }

  &__prizes {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 120px 100px;

    &_title {
      padding-bottom: 80px;
    }
  }
}

@media screen and (max-width: 2560px) {
  .home {
    &_purple {
      & .home__prizes {
        background: none;
        background-color: $color-purple-10;
      }
    }

    &_red {
      & .home__prizes {
        background: none;
        background-color: $color-red-10;
      }
    }
  }
}

@media screen and (max-width: 1920px) {
  .home {
    &_purple {
      & .home__prizes {
        background: $color-purple-10 url("@/assets/images/background-pattern-big.svg") no-repeat scroll;
      }
    }

    &_red {
      & .home__prizes {
        background: $color-red-10 url("@/assets/images/background-pattern-red-big.svg") no-repeat scroll;
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .home {
    &_purple {
      & .home__prizes {
        background: $color-purple-10 url("@/assets/images/background-pattern.svg") no-repeat scroll;
      }
    }

    &_red {
      & .home__prizes {
        background: $color-red-10 url("@/assets/images/background-pattern-red.svg") no-repeat scroll;
      }
    }
  }
}

@media screen and (max-width: 1315px) {
  .home {
    &__rules {
      width: 100%;
      padding: 0 0 140px 26px;

      &_rules {
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }

    &__prizes {
      padding: 0 0 100px 26px;
    }
  }
}

@media screen and (max-width: 1180px) {
  .home {
    &__banner {
      &_container {
        left: 38%;
      }
    }
  }
}

@media screen and (max-width: 980px) {
  .home {
    &__banner {
      height: 640px;

      &_container {
        left: 16%;
        top: 40%;
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .home {
    &__banner {
      height: 580px;
    }
  }
}

@media screen and (max-width: 710px) {
  .home {
    &__banner {
      height: 580px;
      margin-bottom: 60px;

      &_container {
        max-width: 543px;
        top: 56%;
      }

      &_title {
        font-size: 100px;
        line-height: 100px;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .home {
    &__rules {
      padding: 0 0 58px 26px;

      &_title {
        padding-bottom: 38px;
      }
    }

    &__prizes {
      &_title {
        padding-bottom: 40px;
      }
    }
  }
}

@media screen and (max-width: 570px) {
  .home {
    &__banner {
      &_container {
        max-width: 446px;
      }
    }
  }
}

@media screen and (max-width: 468px) {
  .home {
    &__banner {
      height: 470px;

      &_container {
        max-width: 320px;
        top: 70%;
      }

      &_text {
        font-size: 22px;
      }
    }
  }
}

@media screen and (max-width: 440px) {
  .home {
    &__banner {
      height: 470px;

      &_container {
        max-width: 288px;
        top: 64%;
      }

      &_text {
        line-height: 26px;
      }
    }
  }
}
</style>
